import ModalOptions, { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import eventBus from './eventBus';
import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import { IBusinessType } from '@/models/business';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import { getMerchantMeetingOboardingState } from '@/router/router-utils';
import { EOnboardingMeetingStatus } from '@/models/onboarding-call';
import { getBillingIsHidden, getBillingIsPending } from './billing';
import { isOnboardingCallHidden } from './onboardingCall';

const openCenterModalConfig = (
  modalName: string,
  mobilePositionBottom?: boolean
) =>
  new ModalOptions(
    ``,
    ``,
    'none',
    true,
    ``,
    ``,
    ``,
    false,
    modalName,
    false,
    true,
    true,
    false,
    false,
    null,
    true,
    mobilePositionBottom
  );

export const openCenterModal = (modalName: string, ...args: any) => {
  eventBus.$emit(
    'openSubModal',
    openCenterModalConfig(modalName, args && args.mobilePositionBottom),
    ...args
  );
};

export const openDefaultModal = (modalName: string, ...args: any) => {
  eventBus.$emit(
    'openSubModal',
    new ModalOptionsV2({
      componentToRender: modalName,
      hideCancelButton: false,
      icon: '',
      mobileFullScreen: false,
      mobilePositionBottom: true
    }),
    args
  );
};

// The single switch behind the location-benefits modal: it is the only thing that
// sets the route param Home reads, and both onboarding exits go through it too. So
// one guard here decides for every place the modal can appear, which is the "decide
// once" TWISM-19011 and TWISM-19006 both asked for.
export const showModalBillingLocationBenefits = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;

  if (!business || business.type === IBusinessType.INSTORE) return false;

  // With billing hidden only the online variant survives: the modal stops
  // pitching the Coin Network plan and keeps just the add-location prompt,
  // which only makes sense for online merchants (TWISM-19139).
  if (getBillingIsHidden() && business.type !== IBusinessType.ONLINE)
    return false;

  return (
    app.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV4) &&
    business.country === 'United States' &&
    (getBillingIsPending() ||
      business.subscriptionStatus === EBillingStatusTypes.UNAVAILABLE)
  );
};

// The route-entry Coin Network billing modals: the welcome one on the delayed
// period and the news one otherwise. Both also start the billing guided tour, so
// this single switch takes the tour with them while billing is hidden
// (TWISM-19005). Falling through rather than short-circuiting is deliberate: the
// merchants this shields are then eligible for whatever comes next in the chain,
// which is the end state the epic wants.
export const showModalCoinNetworkBilling = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;

  if (!business || getBillingIsHidden()) return false;

  return (
    Object.keys(business).includes('seenCoinNetworkGuidedTour') &&
    !business.seenCoinNetworkGuidedTour &&
    app.$store.getters['flags/getFlags'].includes(flagKeys.billingModuleV3) &&
    (business.subscriptionStatus === EBillingStatusTypes.DELAY_PERIOD ||
      business.subscriptionStatus === EBillingStatusTypes.SUBSCRIBED)
  );
};

export const showModalOnboardingCall = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;

  if (!business || business.type !== IBusinessType.INSTORE) return false;

  return (
    app.$store.getters['flags/getFlags'].includes(
      flagKeys.showOnboardingCallBanner
    ) &&
    !isOnboardingCallHidden() &&
    business.country === 'United States' &&
    !!business.onboardingMeeting &&
    business.onboardingMeeting.status === EOnboardingMeetingStatus.PENDING &&
    !getMerchantMeetingOboardingState()
  );
};
